import React from 'react';
import {
  Select,
  TreeSelect,
  TreeSelectProps,
  SelectProps,
  Modal,
  ModalProps,
} from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import ReactDom from 'react-dom';
import { FilterSelectPc, FilterSelectPcProps } from '../FilterSelect/FilterSelectPc';
import styled from 'styled-components';
import '../filterPc.less'

const FilterModalView = styled(Modal)`
  &.ant-modal .ant-modal-content{
    padding: 0;
    border-radius: 0;
    position: absolute;
    height: 100%;
  }
  &.ant-modal .ant-modal-body{
    height: 100%;
  }
`

const FilterModal = (props: ModalProps) => {
  const { className, style, ...reset } = props;
  const defaultStyle = {
    width: '100%',
    maxWidth: '100%',
    margin: 0,
    top: 0,
    position: 'absolute' as const,
    bottom: '100px',
    padding: 0,
  };
  
  return (
    <FilterModalView
      destroyOnClose
      transitionName="ant-slide-up"
      className={`filter-modal ${className || ''}`}
      width={'100%'}
      style={{
        ...defaultStyle,
        ...style,
      }}
      closable={false}
      footer={null}
      {...reset}
    >
      {props.children}
    </FilterModalView>
  );
};

const isEmptySelectValue = (value:[]|string|undefined)=>{
  if(Array.isArray(value)){
    return value.length === 0
  }
  return value === undefined || value === ''
}

interface SelectModalPcProps extends FilterSelectPcProps {
  onShowMoreToggle?: (visible: boolean) => void;
  MoreComponent?: React.FunctionComponent<{ onClose(): void }>;
  showMore?: boolean;
}
export const SelectModalPc = (props: SelectModalPcProps) => {
  let value = props.value;
  // const { showMore = false } = props
  let { onShowMoreToggle = () => {}, MoreComponent, ...reset } = props;
  const [showMore, setShowMore] = React.useState(false);
  
  // 检测是否为 AI Chat 模式
  const isAiChat = React.useMemo(() => {
    return new URLSearchParams(window.location.search).get('render-type') === 'ai-chat';
  }, []);
  
  let suffixIcon = isEmptySelectValue(value) ? (<EllipsisOutlined onClick={() => setShowMore(true)}  style={{ fontSize: '20px' }} />) : undefined;
  // let allowClear = value !== undefined  || undefined
  return (
    <div>
      <FilterSelectPc suffixIcon={suffixIcon}  allowClear {...reset} defaultFilterOption/>
      <FilterModal 
        open={showMore}  
        onCancel={() => setShowMore(false)}
        style={{
          width: '100%',
          maxWidth: '100%',
          margin: 0,
          top: 0,
          position: 'absolute',
          bottom: isAiChat ? '0' : '100px',
          padding: 0,
        }}
      >
        {showMore && MoreComponent && (
          <MoreComponent onClose={() => setShowMore(false)} />
        )}
      </FilterModal>
    </div>
  );
};
